import React from 'react';
import XpressTemplateKioskTable from './XpressTemplateKioskTable';
import { browserHistory } from 'react-router';
import Api from '../Api';
import * as actions from '../redux/actions';

const kioskTableWidth = 1000;
const kioskTableHeight = 350;
const barColor = '#216887';

class XpressTemplateCreateForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      kioskRows: [],
      filteredRows: [],
      templateName: '',
      description: '',
      clickedKiosk: '',
    };

    Api.getKioskList('name, getlocname(location), getorgname(org)').then((data) => {
      let kiosklist = data.map((kiosk) => {
        return {
          org: kiosk['getorgname(org)'],
          location: kiosk['getlocname(location)'],
          kiosk: kiosk.name,
        };
      });
      this.setState({ kioskRows: kiosklist, filteredRows: kiosklist });
    });

    this.handleTemplateName = this.handleTemplateName.bind(this);
    this.handleTemplateDescription = this.handleTemplateDescription.bind(this);
    this.handleKioskClick = this.handleKioskClick.bind(this);
    this.onFilterChange = this.onFilterChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

  handleTemplateName(event) {
    this.setState({ templateName: event.target.value });
  }

  handleTemplateDescription(event) {
    this.setState({ description: event.target.value });
  }

  handleKioskClick(event, index) {
    let kiosk = this.state.filteredRows[index].kiosk;
    this.setState({ clickedKiosk: kiosk });
  }

  onFilterChange(e) {
    let filterBy = e.target.value.trim().toUpperCase();
    let searchedRows = [];

    for (let kioskRow of this.state.kioskRows) {
      let filterTermMatched = false;

      let kiosk = kioskRow.kiosk || '';
      let location = kioskRow.location || '';
      let org = kioskRow.org || '';

      if (
        kiosk.toUpperCase().includes(filterBy) ||
        location.toUpperCase().includes(filterBy) ||
        org.toUpperCase().includes(filterBy)
      ) {
        filterTermMatched = true;
      }

      if (filterTermMatched) {
        searchedRows.push(kioskRow);
      }
    }

    this.setState({
      filteredRows: searchedRows,
      clickedKiosk: '',
    });
  }

  onSubmit(event) {
    event.preventDefault();

    Api.createXTemplate(
      this.state.clickedKiosk,
      this.state.templateName,
      this.state.description
    ).then((resp) => {
      if (resp.status == 'err') {
        alert(resp.msg);
      } else {
        this.props.dispatch(actions.getXpressTemplateList());
        browserHistory.push({ pathname: '/admin/xpresstemplates' });
      }
    });
  }

  render() {
    return (
      <form
        id='createtemplateform'
        className='user-form pure-form pure-form-stacked'
        style={{ padding: '20px 0' }}
        onSubmit={this.onSubmit}
      >
        <div className='pure-control-group'>
          Template Name
          <input
            className='pure-input-1-4'
            type='text'
            onChange={this.handleTemplateName}
            placeholder='Template Name'
            required
          />
        </div>

        <br />
        <div className='pure-control-group'>
          Description
          <input
            className='pure-input-1-2'
            type='text'
            onChange={this.handleTemplateDescription}
            placeholder='Description'
            style={{ width: kioskTableWidth }}
            required
          />
        </div>

        <br />

        <div className='pure-control-group'>
          <input
            className='pure-input-1-2'
            type='text'
            onChange={this.onFilterChange}
            placeholder='Search for Org Location Kiosk'
            style={{ width: kioskTableWidth }}
          />
          <div className='title' style={{ background: barColor, width: kioskTableWidth }}>
            Choose Kiosk as model
          </div>
          <XpressTemplateKioskTable
            onRowClick={this.handleKioskClick}
            rowsCount={this.state.filteredRows.length}
            rowHeight={50}
            headerHeight={50}
            width={kioskTableWidth}
            height={kioskTableHeight}
            rows={this.state.filteredRows}
            retainClick={true}
          />
        </div>

        <br />
        <div className='pure-controls'>
          <button
            style={{ background: '#216887' }}
            className='pure-button pure-button-primary'
            type='submit'
          >
            Create
          </button>
        </div>
      </form>
    );
  }
}

export default XpressTemplateCreateForm;



// WEBPACK FOOTER //
// ./src/components/XpressTemplateCreateForm.js